const cryptoPolyfill = {
  getRandomValues: (array) => window.crypto.getRandomValues(array),
  subtle: window.crypto.subtle, // Use Web Crypto API for encryption/hashing
  randomFillSync: (buffer) => {
    if (!(buffer instanceof Uint8Array)) {
      throw new TypeError('randomFillSync only supports Uint8Array');
    }
    return window.crypto.getRandomValues(buffer);
  },
};
if (!globalThis.crypto) {
  Object.defineProperty(globalThis, 'crypto', {
    value: cryptoPolyfill,
    configurable: false, // Prevent further modifications
    writable: false, // Make it read-only
  });
}
export default cryptoPolyfill;
